import { ActionType, Image, ImageSize, Link } from '@com-delta-idp/mnx-ui-kit';
import { GenericLabel } from '@com-delta-idp/mnx-utils';

export interface Action {
  type: ActionType;
  link: Link;
  id?: string;
}

export interface Card {
  id?: string;
  type: ImageSize;
  content: Partial<GenericLabel>;
  image: Image;
  image2?: Image;
  tag?: Partial<GenericLabel>;
  action: Action;
}
